import * as constants from "./constants";

export const fetchAutoAssign = (id) => {
  return {
    type: constants.FETCH_AUTO_ASSIGN,
    payload: id,
  };
};

export const fetchAutoAssignSuccess = (data) => {
  return {
    type: constants.FETCH_AUTO_ASSIGN_SUCCESS,
    data: data,
  };
};

export const fetchAutoAssignError = (data) => {
  return {
    type: constants.FETCH_AUTO_ASSIGN_ERROR,
    data: data,
  };
};

export const fetchAutoAssignTime = (id) => {
  return {
    type: constants.FETCH_AUTO_ASSIGN_TIME,
    payload: id,
  };
};

export const fetchAutoAssignTimeSuccess = (data) => {
  return {
    type: constants.FETCH_AUTO_ASSIGN_TIME_SUCCESS,
    data: data,
  };
};

export const fetchAutoAssignTimeError = (data) => {
  return {
    type: constants.FETCH_AUTO_ASSIGN_TIME_ERROR,
    data: data,
  };
};

export const updateAutoAssign = (data) => {
  return {
    type: constants.UPDATE_AUTO_ASSIGN,
    data: data,
  };
};

export const updateAutoAssignSuccess = (data) => {
  return {
    type: constants.UPDATE_AUTO_ASSIGN_SUCCESS,
    data: data,
  };
};

export const updateAutoAssignError = () => {
  return {
    type: constants.UPDATE_AUTO_ASSIGN_ERROR,
  };
};

export const createAutoAssign = (data, id) => {
  return {
    type: constants.CREATE_AUTO_ASSIGN,
    data: data,
  };
};

export const createAutoAssignSuccess = (data) => {
  return {
    type: constants.CREATE_AUTO_ASSIGN_SUCCESS,
    data: data,
  };
};

export const createAutoAssignError = (id) => {
  return {
    type: constants.CREATE_AUTO_ASSIGN_ERROR,
    id,
  };
};

export const updateAutoTime = (data, id) => {
  return {
    type: constants.UPDATE_AUTO_TIME,
    data: data,
  };
};

export const updateAutoTimeSuccess = (data) => {
  return {
    type: constants.UPDATE_AUTO_TIME_SUCCESS,
    data: data,
  };
};

export const updateAutoTimeError = (id) => {
  return {
    type: constants.UPDATE_AUTO_TIME_ERROR,
    id,
  };
};

export const updateAutoNow = (data, id) => {
  return {
    type: constants.UPDATE_AUTO_NOW,
    data: data,
  };
};

export const updateAutoNowSuccess = (data) => {
  return {
    type: constants.UPDATE_AUTO_NOW_SUCCESS,
    data: data,
  };
};

export const updateAutoNowError = (id) => {
  return {
    type: constants.UPDATE_AUTO_NOW_ERROR,
    id,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};

export const setStorage = (data) => {
  return {
    type: constants.SET_AUTO_MANAGER_STATE,
    data,
  };
};
